<template>
  <div>
    <Listbox
      v-slot="{ open }"
      v-model="selected"
      class="w-full"
    >
      <div class="relative bg-white whitespace-nowrap w-full">
        <ListboxButton
          class="w-full border-t border-l border-r border-gray-400 hover:bg-gray-100 rounded-t-md"
          :class="[!open && 'border-b rounded-b-md']"
        >
          <div class="w-full px-2 py-1 flex flex-row justify-between items-center">
            <!-- 仕様: PC など画面サイズが大きい時はスクロールバーを表示する分の余白を取る -->
            <div class="flex-grow-0 min-w-0">
              <slot name="selected" />
            </div>
            <BaseIcon
              icon="arrow_down"
              class="flex-shrink-0 text-gray-800"
              :size="24"
            />
          </div>
          <div v-if="open" class="mx-1 border-gray-400 border-b" />
        </ListboxButton>
        <!-- 仕様: PC など画面サイズが大きい時はスクロールバーを表示する。普段は隠す。 -->
        <ListboxOptions
          :class="[
            'absolute z-10 bg-white w-full',
            'text-gray-800',
            open && 'border-l border-b border-r border-gray-400 rounded-b-md'
          ]"
        >
          <div class="w-full max-h-40 hidden-scrollbar overflow-auto">
            <slot name="options" />
          </div>
        </ListboxOptions>
      </div>
    </Listbox>
  </div>
</template>

<script lang="ts">
import { Listbox, ListboxButton, ListboxOptions } from '@headlessui/vue';
import { useVModel } from '@vueuse/core';
import { defineComponent } from 'vue';

import BaseIcon from '@/components/BaseIcon.vue';

export default defineComponent({
  name: 'BaseSelect',
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    BaseIcon,
  },
  props: {
    modelValue: {
      type: null,
      required: true,
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const selected = useVModel(props, 'modelValue', emit);

    return {
      selected,
    };
  },
});
</script>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .hidden-scrollbar {
    -ms-overflow-style: none; /* IE, Edge 対応 */
    scrollbar-width: none; /* Firefox 対応 */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari 対応 */
    }
  }
}
</style>
